import { Backdrop, Button, Icon, IconButton, Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { ResolutionType } from "application/contexts/screen/ScreenStore";
import { InputCpfCnpj } from "areas/payment/inputCpfCnpj/InputCpfCnpj";
import BottomModal from "components/bottomModal/BottomModal";
import PromiseBottomModal from "components/promiseBottomModal/PromiseBottomModal";
import { TransactionType } from "domains/order/agreggates/payment/transactionType";
import { ICartItem } from "modules/cart/domain/models/ICart";
import { IOrder } from "modules/cart/domain/models/IOrder";
import { IPaymentResult } from "modules/payment/presentation/PaymentProvider";
import React, { FC } from "react";
import { ReactComponent as Delivery } from "../../../../assets/icons/delivery.svg";
import { ReactComponent as Majority } from "../../../../assets/icons/majority.svg";
import { ReactComponent as Meal } from "../../../../assets/icons/meal.svg";
import { ReactComponent as Cart } from "../../../../assets/icons/shopping-cart.svg";
import styles from "./CartView.module.scss";
import UseCartView from "./UseCartView";
import Carousel from "./carousel/Carousel";
import { CartItem } from "./cartItem/CartItem";
import { Trans } from "react-i18next";

export interface ICartViewProps {
  onSendOrder: (
    order: IOrder,
    recharge?: "Recharge" | "Payment",
    paymentType?: TransactionType
  ) => Promise<IPaymentResult>;
}

const CartView: FC<ICartViewProps> = ({ onSendOrder }) => {
  const {
    cartBarHandle,
    cartItems,
    showCart,
    kiosk,
    totalWithServiceFee,
    handleClearCart,
    totalServiceFeeValue,
    onConfirmOrder,
    openOrderToGoModal,
    showVerifyMajorityModal,
    onPressSimMaioridade,
    onPressNaoMaioridade,
    resolution,
    openTooltip,
    handleTooltipToggle,
    clearCartRef,
    handleCloseOrderToGoModal,
    handleOrderToGo,
    suggestionProducts,
    showCpfInput,
    toogleCpfInput,
    t,
  } = UseCartView(onSendOrder);

  return (
    <div id={styles.CartView}>
      <Backdrop
        onClick={cartBarHandle}
        style={{ zIndex: 1 }}
        open={Boolean(cartItems.length && showCart)}
      ></Backdrop>
      <div
        className={`${styles.cart} ${
          cartItems.length
            ? showCart
              ? styles.cartOpen
              : styles.cartClosed
            : styles.cartHidden
        }`}
      >
        <div
          className={styles.cartBar}
          style={{ background: showCart ? "white" : "#2DA04C" }}
        >
          {showCart ? (
            <div className={styles.cartBarOpen}>
              <span>{t("cart_view.bar.details")}</span>
              <div onClick={handleClearCart}>
                <Icon>delete_outlined</Icon>
                <span>{t("cart_view.bar.clear")}</span>
              </div>
            </div>
          ) : (
            <div className={styles.cartBarClose} onClick={cartBarHandle}>
              <div>
                <Icon fontSize={"large"}>shopping_cart</Icon>
                {!(kiosk?.hideZeroPrice && totalWithServiceFee === 0) &&
                  "R$ " + totalWithServiceFee.toFixed(2).replace(".", ",")}
              </div>
              <div>
                {t("cart_view.bar.pay")}
                <Icon fontSize={"large"}>keyboard_arrow_up</Icon>
              </div>
            </div>
          )}
        </div>

        <div
          className={styles.container}
          style={{
            padding:
              resolution === ResolutionType.FULL_HD ? "0 28px" : "0 22px",
          }}
        >
          {cartItems.map((orderItem: ICartItem, key: number) => (
            <CartItem
              key={key}
              hideZeroPrice={kiosk?.hideZeroPrice}
              orderItem={orderItem}
            />
          ))}
        </div>
        <div className={styles.footer}>
          {suggestionProducts.length > 0 && (
            <div className={styles.suggestions}>
              <span>
                <Trans i18nKey="cart_view.suggestions.also">
                  Peça <b>também</b>
                </Trans>
              </span>
              <Carousel products={suggestionProducts} />
            </div>
          )}
          {!(kiosk?.hideZeroPrice && totalWithServiceFee === 0) && (
            <div
              className={styles.resume}
              style={{
                margin:
                  resolution === ResolutionType.FULL_HD ? "0 28px" : "0 22px",
              }}
            >
              {kiosk?.serviceRate && kiosk.serviceRatePercent && (
                <>
                  <div
                    className={styles.subtotal}
                    style={{
                      fontSize: resolution === ResolutionType.FULL_HD ? 28 : 22,
                    }}
                  >
                    <div>{t("cart_view.summary.subtotal")}</div>
                    <div>
                      R$
                      {(totalWithServiceFee - totalServiceFeeValue)
                        .toFixed(2)
                        .replace(".", ",")}
                    </div>
                  </div>
                  <div
                    className={styles.serviceFeeTotal}
                    style={{
                      fontSize: resolution === ResolutionType.FULL_HD ? 28 : 22,
                    }}
                  >
                    <div>
                      {t("cart_view.summary.service_fee")}
                      <Tooltip
                        title={
                          t("cart_view.summary.service_fee_tooltip", {
                            percent: (kiosk?.serviceRatePercent ?? 0) * 100,
                          }) ?? ""
                        }
                        placement="right"
                        open={openTooltip}
                      >
                        <IconButton onClick={handleTooltipToggle}>
                          <InfoOutlined />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <div>
                      R${totalServiceFeeValue.toFixed(2).replace(".", ",")}
                    </div>
                  </div>
                </>
              )}
              <div
                className={styles.total}
                style={{
                  fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
                }}
              >
                <div>{t("cart_view.summary.total")}</div>
                <div>R${totalWithServiceFee.toFixed(2).replace(".", ",")}</div>
              </div>
            </div>
          )}

          <div
            className={styles.buttonsContainer}
            style={{
              margin: resolution === ResolutionType.FULL_HD ? 28 : 22,
            }}
          >
            <div
              style={{
                marginRight: resolution === ResolutionType.FULL_HD ? 8 : 6,
              }}
              onClick={cartBarHandle}
            >
              {t("cart_view.buttons.continue_shopping")}
            </div>
            <div
              onClick={onConfirmOrder}
              style={{
                marginLeft: resolution === ResolutionType.FULL_HD ? 8 : 6,
              }}
            >
              {t("cart_view.buttons.pay")}
            </div>
          </div>
        </div>
        <BottomModal
          showModal={showCpfInput}
          onClickClose={onPressNaoMaioridade}
        >
          <InputCpfCnpj
            required={true}
            onPressContinuar={onPressSimMaioridade}
          />
        </BottomModal>
        <BottomModal
          showModal={showVerifyMajorityModal}
          onClickClose={onPressNaoMaioridade}
        >
          <div className={styles.majorityModal}>
            <span>
              <Trans i18nKey="cart_view.majority_modal.question">
                Ei, você possui mais de <b>18 anos</b>?
              </Trans>
            </span>
            <Majority />
            <p>{t("cart_view.majority_modal.law")}</p>
            <div>
              <Button onClick={toogleCpfInput}>
                {t("cart_view.majority_modal.yes")}
              </Button>
              <Button onClick={onPressNaoMaioridade}>
                {t("cart_view.majority_modal.no")}
              </Button>
            </div>
          </div>
        </BottomModal>
        <BottomModal
          showModal={openOrderToGoModal}
          onClickClose={handleCloseOrderToGoModal}
          closeButtonTile={t("cart_view.order_to_go_modal.back")}
        >
          <div className={styles.orderToGo}>
            <div onClick={() => handleOrderToGo()}>
              <Meal
                style={{
                  width: resolution === ResolutionType.FULL_HD ? 200 : 100,
                  height: resolution === ResolutionType.FULL_HD ? 200 : 100,
                }}
                color={kiosk?.themeColor ?? kiosk?.primaryColor}
              />
              <span
                style={{
                  fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
                }}
              >
                {t("cart_view.order_to_go_modal.eat_here")}
              </span>
            </div>
            <div onClick={() => handleOrderToGo("PARA VIAGEM")}>
              <Delivery
                style={{
                  width: resolution === ResolutionType.FULL_HD ? 200 : 100,
                  height: resolution === ResolutionType.FULL_HD ? 200 : 100,
                }}
                color={kiosk?.themeColor ?? kiosk?.primaryColor}
              />
              <span
                style={{
                  fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
                }}
              >
                {t("cart_view.order_to_go_modal.take_home")}
              </span>
            </div>
          </div>
        </BottomModal>
        <PromiseBottomModal
          ref={clearCartRef}
          confirmTitle={t("cart_view.clear_cart_modal.yes")}
          closeButtonTile={t("cart_view.clear_cart_modal.no")}
        >
          <div className={styles.emptyCart}>
            <Cart
              color="var(--primary)"
              style={{
                width: resolution === ResolutionType.FULL_HD ? 280 : 200,
                height: resolution === ResolutionType.FULL_HD ? 280 : 200,
              }}
            />
            <p
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 52 : 36,
              }}
            >
              <Trans i18nKey="cart_view.clear_cart_modal.question">
                Deseja realmente <b>limpar o carrinho?</b>
              </Trans>
            </p>
          </div>
        </PromiseBottomModal>
      </div>
    </div>
  );
};
export default CartView;
